var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"ma-0 pa-0",attrs:{"dark":"","color":"primary"}},[_c('v-card-text',{staticClass:"white--text text-center pa-0"},[_c('img',{attrs:{"src":require("@/assets/logo_almeida.png"),"height":"20","max-width":"20"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }